import * as React from 'react';
import { AppContext, IAppContext, IFormStateBase } from '../Types/Intyg.types';
import TaEmotIntyget from '../FormSections/TaEmotIntyget';
import ValjYrke from '../FormSections/ValjYrke';
import Personuppgifter from '../FormSections/Personuppgifter';
import Heading from '../FormSections/Heading';
import Adressuppgifter from '../FormSections/Adressuppgifter';
import FormDivider from '../FormSections/FormDivider';
import SubmitButton from '../FormSections/SubmitButton';
import Villkor from '../FormSections/Villkor';
import { ApplicationType, Section } from '../Types/Intyg.enums';
import DeleteAnsokan from '../FormSections/DeleteAnsokan';
import { FormBase } from '../Types/FormBase';
import MainBody from '../FormSections/MainBody';

export interface IAT_TjanstgoringProps {}

export interface IAT_TjanstgoringState extends IFormStateBase {}

export default class AT_Tjanstgoring extends FormBase<IAT_TjanstgoringProps, IAT_TjanstgoringState> {
  static contextType = AppContext;
  constructor(props: IAT_TjanstgoringProps) {
    super(props);

    this.state = { isFormValid: false };
  }

  public render() {
    const appContext = this.context as IAppContext;

    return (
      <>
        <Heading />
        <MainBody />
        <FormDivider />
        <TaEmotIntyget ref={this.sectionRefMap.get(Section.TaEmotIntyget) as React.RefObject<TaEmotIntyget>} />
        <FormDivider />
        <Personuppgifter ref={this.sectionRefMap.get(Section.Personuppgifter) as React.RefObject<Personuppgifter>} />
        <FormDivider />
        {appContext.model.skickaPost && (
          <>
            <Adressuppgifter
              ref={this.sectionRefMap.get(Section.Adressuppgifter) as React.RefObject<Adressuppgifter>}
            />
            <FormDivider />
          </>
        )}
        {<Villkor ref={this.sectionRefMap.get(Section.Villkor) as React.RefObject<Villkor>} />}
        <SubmitButton isEnabled={this.state.isFormValid} />
        <FormDivider />
        {appContext.applicationType === ApplicationType.Eservice && <DeleteAnsokan />}
        {appContext.model.skickaPdf && (
          <input type="hidden" name="lang_checkbox" value={appContext.Translate('engelska')} />
        )}
      </>
    );
  }
}
